module.exports = __webpack_public_path__ + "img/2.ed2ec0f0.jpg";